module.exports = __webpack_public_path__ + "static/media/comment-alt-share.b9393687.svg";